import { FC } from 'react'
import { Link } from 'react-router-dom'
import { Button, Tabs } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import PageLayout from '../../../components/page-layout/page-layout'
import { dynamicRoutes, routes } from '../../../constants/routes'
import StampOrdersTable from './components/stamp-orders-table/stamp-orders-table'
import styled from 'styled-components'
import useRouteTab from '../../../hooks/use-route-tab'

const TabsStyled = styled(Tabs)`
    .ant-tabs-content {
        height: 100% !important;
    }
    .ant-tabs-tabpane.ant-tabs-tabpane-active {
        height: 100% !important;
        display: flex;
        flex-direction: column;
    }
`

interface StampOrdersPageProps {}

const tabs = ['created', 'processed'] as const

const StampOrdersPage: FC<StampOrdersPageProps> = () => {
    const { activeKey, onTabChange } = useRouteTab({
        tabs,
        defaultTab: 'created',
        getRoute: dynamicRoutes.purchasesStampOrdersTab,
    })

    const tabsItems = [
        {
            label: 'Созданные',
            key: 'created',
            children: <StampOrdersTable tab='created' />,
        },
        {
            label: 'Обработанные',
            key: 'processed',
            children: <StampOrdersTable tab='processed' />,
        },
    ]

    return (
        <PageLayout title={'Заказы штампов'}>
            <TabsStyled
                activeKey={activeKey}
                onChange={onTabChange}
                destroyInactiveTabPane
                type={'card'}
                size={'large'}
                items={tabsItems}
                style={{ flex: '1 1' }}
                tabBarExtraContent={{
                    right: (
                        <Link to={routes.purchasesStampOrderNew}>
                            <Button type={'primary'} icon={<PlusOutlined />}>
                                Создать заказ
                            </Button>
                        </Link>
                    ),
                }}
            />
        </PageLayout>
    )
}

export default StampOrdersPage
